import React from 'react';
import '../styles/DraftEditor.css';

function DraftEditor({ body, onBodyChange, onSave, onCancel, isLoading }) {
  return (
    <div className="draft-editor">
      <textarea
        value={body}
        onChange={(e) => onBodyChange(e.target.value)}
        className="editor-textarea"
        disabled={isLoading}
      />
      <div className="editor-actions">
        <button
          className="btn btn-primary"
          onClick={onSave}
          disabled={isLoading}
        >
          {isLoading ? 'Saving...' : '✓ Save Changes'}
        </button>
        <button
          className="btn btn-secondary"
          onClick={onCancel}
          disabled={isLoading}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default DraftEditor;
